import React from 'react';

import AsyncTable from '../../generic/Table/AsyncTable';
import Titled from '../../layout/Titled';
import api from '../../REST/api';
import { listColumns } from '../merchant-attribution-columns';

function AsyncList() {
  return (
    <Titled title="Merchant Attribution">
      <AsyncTable
        className="select-table"
        keyField="id"
        selectionName="suppliers"
        storedName="SUPPLIER_FILTERS"
        minRows={2}
        allowFilterView
        columns={listColumns}
        allColumns={listColumns}
        queryFn={api.getMerchantAttribution}
      />
    </Titled>
  );
}

export default AsyncList;
